import React, { useEffect, useState } from "react";

import { AwarenessUser } from "./types";
import { getAwarenessUsers } from "./selectors";
import { WebsocketProvider } from "@y-rb/actioncable";

export function useAwarenessUsers(
  provider: WebsocketProvider
): AwarenessUser[] {
  const [users, setUsers] = useState<AwarenessUser[]>([]);

  useEffect(() => {
    const awareness = provider.awareness;
    const handleAwarenessChange = () => {
      setUsers(getAwarenessUsers(provider));
    };

    // Get initial users
    handleAwarenessChange();

    awareness.on("change", handleAwarenessChange);
    return () => {
      awareness.off("change", handleAwarenessChange);
    };
  }, [provider]);

  return users;
}
